import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { FaFilePdf, FaPlayCircle } from 'react-icons/fa';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { ShowPDF } from '../../../CommonUtilities/CommonFunctions/CommonFunction';
import { CONTEXT_HEADING } from '../../../CommonUtilities/Validations/RegularExpAndVar';

const UserManual = () => {
    return (
        <Card className="mb-4 border-0 shadow-sm">
            <Card.Header className="bg-light">
                <h4 className="mb-0 text-primary">
                    <FaPlayCircle className="me-2" />
                    User Manual
                </h4>
            </Card.Header>
            <Card.Body>
                <Row>
                    {/* First Video */}
                    <Col xs={12} md={6} className="mb-3">
                        <Card className="h-100">
                            <Card.Header className="bg-light py-2">
                                <h5 className="mb-0 fs-6">
                                    <FaPlayCircle className="me-1 text-danger" />
                                    Video User Manual (English)
                                </h5>
                            </Card.Header>
                            <Card.Body className="p-0">
                                <div className="ratio ratio-16x9">
                                    <iframe
                                        src={CONTEXT_HEADING === "dsc" ? "https://www.youtube.com/embed/JQ92XJwpZQ8" : "https://youtu.be/DZbRLOzkeJg"}
                                        title="User Manual (English)"
                                        allowFullScreen
                                        className="border-0"
                                    ></iframe>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Second Video */}
                    {/* <Col xs={12} md={6} className="mb-3">
                        <Card className="h-100">
                            <Card.Header className="bg-light py-2">
                                <h5 className="mb-0 fs-6">
                                    <FaPlayCircle className="me-1 text-danger" />
                                    Video User Manual (Telugu)
                                </h5>
                            </Card.Header>
                            <Card.Body className="p-0">
                                <div className="ratio ratio-16x9">
                                    <iframe
                                        src={CONTEXT_HEADING === "dsc" ? "https://www.youtube.com/embed/eyXIaNtOI6o" : ""}
                                        title="User Manual (Telugu)"
                                        allowFullScreen
                                        className="border-0"
                                    ></iframe>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col> */}

                    {/* PDF File */}
                    <Col xs={12} className="mt-2">
                        <Card className="border-0 bg-light">
                            <Card.Body className="d-flex align-items-center">
                                <FaFilePdf size={32} className="text-danger me-3" />
                                <div>
                                    <h5 className="mb-1">User Manual Document</h5>
                                    <p className="mb-2 text-muted small">Detailed step-by-step instructions for completing your registration </p>
                                    {/* Replace the href with your actual PDF URL */}
                                    <a
                                        href="#"
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (CONTEXT_HEADING === "TET") {
                                                ShowPDF(process.env.PUBLIC_URL + "/TET-PDF/UserManual/User Manual.pdf");
                                            }
                                            if (CONTEXT_HEADING === "DSC") {
                                                ShowPDF(config.url.FILE_VIEW_URL + 'DSC_PUBLIC_UPLOADS/1745112162841_.pdf')
                                            }
                                        }}
                                    >
                                        Download User Manual
                                    </a>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default UserManual;
